"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _styles2.alpha;
  }
});
Object.defineProperty(exports, "blend", {
  enumerable: true,
  get: function get() {
    return _system.blend;
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function get() {
    return _styles2.createStyles;
  }
});
Object.defineProperty(exports, "css", {
  enumerable: true,
  get: function get() {
    return _styles2.css;
  }
});
Object.defineProperty(exports, "darken", {
  enumerable: true,
  get: function get() {
    return _styles2.darken;
  }
});
Object.defineProperty(exports, "emphasize", {
  enumerable: true,
  get: function get() {
    return _styles2.emphasize;
  }
});
Object.defineProperty(exports, "keyframes", {
  enumerable: true,
  get: function get() {
    return _styles2.keyframes;
  }
});
Object.defineProperty(exports, "lighten", {
  enumerable: true,
  get: function get() {
    return _styles2.lighten;
  }
});
Object.defineProperty(exports, "makeStyles", {
  enumerable: true,
  get: function get() {
    return _styles.makeStyles;
  }
});
Object.defineProperty(exports, "styled", {
  enumerable: true,
  get: function get() {
    return _styles2.styled;
  }
});
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function get() {
    return _styles2.useTheme;
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _styles.withStyles;
  }
});
var _styles = require("@mui/styles");
var _system = require("@mui/system");
var _styles2 = require("@mui/material/styles");